import React from 'react';
import { useRouterActions } from '../use-router-actions';
export const RouterActions = _ref => {
  let {
    children
  } = _ref;
  const actions = useRouterActions();
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(actions));
};
RouterActions.displayName = 'RouterActions';